export const dataFilterTypes = ['TRANSACTIONTYPE', 'TRANSACTIONAMOUNT'];

export const dataFilterOperators = ['=', '!=', '>', '<', '>=', '<='];
